const status = {
  title: 'DC system status',
  meta: [],
}

const type = {
  title: 'DC system type',
  meta: [
    {
      key: 'manufacturer',
      label: 'Manufacturer',
      type: 'text',
    },
    {
      key: 'dc_type',
      label: 'DC Type',
      type: 'text',
    },
    {
      key: 'product_code',
      label: 'Product code',
      type: 'text',
    },
    {
      key: 'w_d_h',
      label: 'W x D x H (cm)',
      type: 'text',
    },
    {
      key: 'max_#_of_recifiers',
      label: 'Max # of recifiers',
      type: 'int',
    },
    {
      key: 'max_power',
      label: 'Max power (W)',
      type: 'double',
    },
    {
      key: 'max_#_of_fuses_priority',
      label: 'Max # of fuses (Priority)',
      type: 'int',
    },
    {
      key: 'max_#_of_fuses_non_priority',
      label: 'Max # of fuses (Non-Priority)',
      type: 'text',
    },
    {
      key: 'fuses_manufacturer',
      label: 'Fuses manufacturer',
      type: 'text',
    },
    {
      key: 'indoor_outdoor',
      label: 'Indoor/outdoor type',
      type: 'options',
      options: [
        {
          text: 'Indoor',
          value: 'indoor',
        },
        {
          text: 'Outdoor',
          value: 'outdoor',
        },
      ],
    },
    {
      key: 'equipment_comment',
      label: 'Equipment Comment',
      type: 'multiline',
    },
    {
      key: 'documents',
      label: 'Document Att.',
      type: 'fileupload',
    },
  ],
}

export default {
  type: type,
  status: status,
}
